import React from 'react'
import { Routes, Route } from 'react-router-dom'

import { RegistrationContainer } from '../../components/RegistrationContainer'
import { PaginationProvider } from '../../contexts/PaginationContext'
import { useBreadcrumb } from '../../hooks/useBreadcrumb'

import { ServicesTable, ServiceForm } from './components'

export const Services: React.FC = () => {
  const breadcrumb = useBreadcrumb({
    servicos: 'Serviços',
    inclusao: 'Inclusão',
    edicao: 'Edição'
  })

  return (
    <RegistrationContainer breadcrumbItems={breadcrumb}>
      <PaginationProvider>
        <Routes>
          <Route path="/" element={<ServicesTable />} />
          <Route path="/inclusao" element={<ServiceForm />} />
          <Route path="/edicao" element={<ServiceForm />} />
        </Routes>
      </PaginationProvider>
    </RegistrationContainer>
  )
}
